module.exports = __webpack_public_path__ + "static/img/img14.78ae4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img14.png
// module id = P8Gw
// module chunks = 0